module.exports = __webpack_public_path__ + "img/提示.b9cfe72d.png";